module.exports = __webpack_public_path__ + "img/shop_A_5.ae48d3ba.png";